import React, { useEffect, useState, useRef, useMemo } from "react";
import Footer from "../../../../../../components/home_page/Footer";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ledgerPostingList } from "../../../../../../redux/actions/action-creator";
import LedgerBook from "../LedgerBook";
import { toast } from "react-toastify";
import { voucherEntryDelete } from "../../../../../../redux/actions/action-creator";
import { currencyFormate } from "../../../../../../components/Date_Formate_Utilitiy/Index";
import {
  openModal,
  closeModal,
  savePageHistory,
} from "../../../../../../redux/actions/action-creator";
import HomeLayout from "../../../../../../components/home_page/HomeLayout";
import NavLayout from "../../../../../../components/NavNameOfComponent/NavLayout";
import Indicator from "../../../../../../components/Indicator/Indicator";
import LedgerVoucherFooter from "../../../../../../components/Footer/LedgerVoucherFooter";
import DeletConfirm from "../../../../../../components/Modal/DeletConfirm";
import { prepareFormData } from "../../../../../../components/Custom_Hooks/useFormHandler";
import { useDelet } from "../../../../../../components/Custom_Hooks/useDelete";
import { useDropdownScroll } from "../../../../../../components/Custom_Hooks/useDropdownScroll";
import { useDropdownKeyboardNavigation } from "../../../../../../components/Custom_Hooks/useDropdownKeyboardNavigation";
import { dateFormateShow, dateFormateSend, getVoucherDate, getValidPeriodDate } from "../../../../../../components/Date_Formate_Utilitiy/Index";

const LedgerVoucher = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [record, setrecord] = useState(false);
  const [loading, setLoading] = useState(true);

  const [removedItems, setRemovedItems] = useState([]);
  const boxRef = useRef(null);

  const [all_data, setall_data] = useState({
    main_ledger_record: {},
    voucherEntryList: [],
  });

  const [closing_balance, setClosingBalance] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const { company_session } = useSelector((state) => state.common);
  const page_history = useSelector((state) => state.common.page_history || {});
  const { userData } = useSelector((state) => state.auth);
  const modal_state = useSelector((state) => state.common.modal_state);
  const location = useLocation();

  const { shouldReset, history } = useMemo(() => {
    const history = page_history[location.pathname];
    const shouldReset = location.state?.resetId && location.state.resetId !== history?.lastResetId;
    return { shouldReset, history };
  }, [location.pathname, page_history, location.state?.resetId]);

  const initialIndexFromHistory = shouldReset ? 0 : (history?.selectedItemIndex || 0);

  const date_formated_send = dateFormateSend(company_session?.current_date);
  const date_formated_show = dateFormateShow(company_session?.current_date);

  const [state, setState] = useState({
    opening_balance: "",
    total_credit_amount: "",
    total_debit_amount: "",
  });

  const [state_configure, setState_configure] = useState({
    show_narrations: "No",
    formate_of_report: "Condensed",
    show_bill_wise_details: "No",
    show_inventory_details: "No",
    show_mode_of_payment: "No",
    show_additional_bank_details: "No",
    display_name_for_ledgers: "Name Only",
    display_name_for_stock_items: "Name Only",
    sorting_method: "Default",
    show_running_balance: "Yes",
  });
  // Set dates in state to send userInterface and server
  const [date, setDate] = useState(shouldReset ? {
    from_date: dateFormateShow(company_session?.start_financial_year),
    to: date_formated_show,
  } : (history?.date || {
    from_date: dateFormateShow(company_session?.start_financial_year),
    to: date_formated_show,
  }));
  const [send_date, setsend_date] = useState(shouldReset ? {
    from_date: dateFormateSend(company_session?.start_financial_year),
    to_date: date_formated_send,
  } : (history?.send_date || {
    from_date: dateFormateSend(company_session?.start_financial_year),
    to_date: date_formated_send,
  }));

  // keyboard Functionality ----------------------------------------
  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      items: all_data?.voucherEntryList,
      state:
        modal_state?.period ||
          modal_state?.otherLedger ||
          modal_state?.configure ||
          modal_state?.delete ||
          modal_state?.otherLedger ||
          modal_state?.period ||
          modal_state?.configure ||
          modal_state?.otherLedger ||
          modal_state?.period
          ? false
          : true,
      onItemSelect: (item) => {
        navigate(`../voucher-transaction-view/${item?.voucher_entries_id > 0 ? item?.voucher_entries_id : item?.uid}`);
      },
      onItemControlEnterSelect: (item) => {
        navigate(`../voucher-transaction-alter/${item?.voucher_entries_id > 0 ? item?.voucher_entries_id : item?.uid}`);
      },
      onItemAltCSelect: (item) => { },
      onItemAltDSelect: (item) => {
        dispatch(openModal("delete"));
      },
      onItemAltASelect: (item) => {
        navigate(`../voucherstransaction`, {
          state: {
            create_date: dateFormateShow(item?.create_date),
            voucher_type_id: item?.voucher_type_id,
            voucher_type_name: item?.voucher_type_name
          }
        });
      },
      onItemSpaceSelect: (item) => {
        toggleSelection(selectedItemIndex);
      },
      onItemAlt2Select: (item) => {
        navigate(`../voucher-transaction/${item?.voucher_entries_id > 0 ? item?.voucher_entries_id : item?.uid}`);
      },
      onItemAltISelect: (item) => {
        navigate(`../voucher-transaction/${item?.voucher_entries_id > 0 ? item?.voucher_entries_id : item?.uid}`);
      },
      onItemAltRSelect: (item) => {
        removeSelectedItems();
      },
      onItemAltUSelect: (item) => {
        restoreSelectedItems();
      },
      onItemF2Select: (item) => {
        dispatch(openModal("period"));
      },
      onItemAltF2Select: (item) => {
        dispatch(openModal("period"));
      },
      onItemF4Select: (item) => {
        navigate('/ledgerbook')
      },
      onItemF12Select: (item) => {
        dispatch(openModal("configure"));
      },
      initialIndex: initialIndexFromHistory,
      enableAlphaJump: true,
      getLabel: (item) => {
        const isSalesPurchase =
          item?.voucher_type?.toLowerCase().includes('sale') ||
          item?.voucher_type?.toLowerCase().includes('purchase') ||
          item?.voucher_type?.toLowerCase().includes('debit note') ||
          item?.voucher_type?.toLowerCase().includes('credit note');
        if (isSalesPurchase) {
          return item?.particular_ledger_name || '';
        }
        return item?.particular_ledger_pos?.[0]?.particular_ledger_name || '';
      },
      containerRef: boxRef,
    });

  // Save selected index to history when it changes
  useEffect(() => {
    dispatch(savePageHistory(location.pathname, {
      selectedItemIndex,
      lastResetId: location.state?.resetId || history?.lastResetId,
      date,
      send_date
    }));
  }, [selectedItemIndex, location.pathname, dispatch, location.state?.resetId, date, send_date]);

  // Handle Alt+F1 shortcut for toggling report format
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (modal_state?.period || modal_state?.configure || modal_state?.delete) {
        return;
      }
      if (e.altKey && e.key === "F1") {
        e.preventDefault();
        setState_configure((prev) => ({
          ...prev,
          formate_of_report: prev.formate_of_report === "Detailed" ? "Condensed" : "Detailed",
        }));
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [modal_state]);

  const [data, setData] = useState({
    uid: all_data?.voucherEntryList[selectedItemIndex]?.uid,
    company_id: userData?.company_id,
  });

  useEffect(() => {
    setClosingBalance(
      (parseFloat(state?.total_debit_amount) || 0) -
      (parseFloat(state?.total_credit_amount) || 0) +
      (parseFloat(state?.opening_balance) || 0)
    );
  }, [
    state?.total_debit_amount,
    state?.total_credit_amount,
    state?.opening_balance,
  ]);

  // Fetch Data ------------------------------------------------------------
  useEffect(() => {
    const fetchData = async () => {
      try {
        let formdata = new FormData();
        const fetchFromDate = company_session?.start_financial_year ? dateFormateSend(company_session?.start_financial_year) : send_date?.from_date;
        formdata.append("fromDate", fetchFromDate);
        formdata.append("toDate", send_date?.to_date);
        formdata.append("ledger_id", id);
        formdata.append("company_id", userData?.company_id);
        const response = await dispatch(ledgerPostingList(formdata));
        if (response?.data) {
          //console.log("response", response);
          // Group vouchers by a composite key (date + type + serial_no) to ensure all entries of one voucher are grouped
          const currentLedgerId = parseInt(id);
          const groupedVouchers = (response.data.voucherEntryList || []).reduce((acc, curr) => {
            const dateStr = curr.create_date ? new Date(curr.create_date).toDateString() : "";
            const vchId = (curr.voucher_entries_id && curr.voucher_entries_id !== 0 && curr.voucher_entries_id !== "0")
              ? curr.voucher_entries_id
              : curr.uid;
            const key = vchId ? String(vchId) : `${dateStr}_${curr.voucher_type_id}_${curr.serial_no}`;
            const debit = parseFloat(String(curr.total_debit_amount).replace(/,/g, "")) || 0;
            const credit = parseFloat(String(curr.total_credit_amount).replace(/,/g, "")) || 0;
            if (!acc[key]) {
              acc[key] = { ...curr };
              acc[key].total_debit_amount = debit;
              acc[key].total_credit_amount = credit;
              acc[key].particular_ledger_pos = [];
              acc[key]._mainLedgerCount = 0;
            }
            let posArray = curr.particular_ledger_pos || curr.particular_data || curr.data;

            if (typeof posArray === 'string') {
              try {
                posArray = JSON.parse(posArray);
              } catch (e) {
                posArray = [];
              }
            }
            const aggregated = acc[key].particular_ledger_pos;
            (Array.isArray(posArray) ? posArray : []).forEach(pos => {
              const posLedgerId = pos.particular_ledger_id || pos.ledger_id || pos.id;
              if (String(posLedgerId) === String(id)) {
                acc[key]._mainLedgerCount++;
                if (acc[key]._mainLedgerCount > 1) {
                  const amt = parseFloat(String(pos.particular_ledger_pay_amount || 0).replace(/,/g, "")) || 0;
                  if (pos.transaction_type === 'CR') {
                    acc[key].total_credit_amount += amt;
                  } else if (pos.transaction_type === 'DR') {
                    acc[key].total_debit_amount += amt;
                  }
                }
                return;
              }

              const amt = parseFloat(String(pos.particular_ledger_pay_amount || 0).replace(/,/g, "")) || 0;
              const existing = aggregated.find(p => String(p.particular_ledger_id) === String(pos.particular_ledger_id) && p.transaction_type === pos.transaction_type);

              if (!existing) {
                aggregated.push({ ...pos, particular_ledger_pay_amount: amt });
              } else if (aggregated.length === 0 || !acc[key]._processedRows?.includes(curr.id || curr.uid)) {
                // If we want to sum them up if they are distinct entries in the same voucher
                // existing.particular_ledger_pay_amount += amt; 
                // But usually, if the same ledger+type appears, it's either a duplicate from a split row or a distinct line item.
                // For now, we just ensure we don't skip the first row's entries.
              }
            });

            if (!acc[key]._processedRows) acc[key]._processedRows = [];
            acc[key]._processedRows.push(curr.id || curr.uid);
            return acc;
          }, {});

          const uniqueVoucherEntryList = Object.values(groupedVouchers).sort((a, b) => {
            return new Date(a.create_date) - new Date(b.create_date);
          });

          // Calculate dynamic opening balance and filter transactions client-side
          const initialOpening = parseFloat(response.data.opening_balance) || 0;
          let calculatedOpening = initialOpening;

          const filterStartDate = new Date(send_date?.from_date);
          filterStartDate.setHours(0, 0, 0, 0);

          const displayedVouchers = [];

          uniqueVoucherEntryList.forEach(item => {
            const itemDate = new Date(item.create_date);
            itemDate.setHours(0, 0, 0, 0);

            if (itemDate < filterStartDate) {
              const debit = parseFloat(item?.total_debit_amount) || 0;
              const credit = parseFloat(item?.total_credit_amount) || 0;
              calculatedOpening += (debit - credit);
            } else {
              displayedVouchers.push(item);
            }
          });

          setall_data({
            main_ledger_record: response.data.main_ledger_record,
            voucherEntryList: displayedVouchers,
          });

          let current_debit_total_amount = 0;
          let current_credit_total_amount = 0;
          displayedVouchers?.map((item, ind) => {
            return (
              (current_debit_total_amount += parseFloat(
                item?.total_debit_amount
              )),
              (current_credit_total_amount += parseFloat(
                item?.total_credit_amount
              ))
            );
          });
          setState({
            opening_balance: calculatedOpening,
            total_credit_amount: current_credit_total_amount,
            total_debit_amount: current_debit_total_amount,
          });
        }
      } catch (error) {
        console.error("Error fetching group data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [send_date, date, id, refreshKey]);

  // Scroll Functionality -------------------------------------
  useDropdownScroll({ dropdownRef: boxRef, selectedItemIndex });

  // Function to toggle selection of an item
  const toggleSelection = (index) => {
    const selectedIndex = selectedItems.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      // Add the item to the selection if not already selected
      newSelected = newSelected.concat(selectedItems, index);
    } else if (selectedIndex === 0) {
      // Remove the item from the selection if already selected
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }
    setSelectedItems(newSelected);
  };

  // Function to remove selected items
  const removeSelectedItems = () => {
    // If multiple items are selected, remove all selected items
    if (selectedItems.length > 0) {
      const selectedIndices = [...selectedItems].sort((a, b) => a - b);
      const removedItemsList = selectedIndices.map(index => ({
        index: index,
        item: all_data?.voucherEntryList[index]
      }));

      // Filter out selected items from the list
      const updatedData = all_data?.voucherEntryList?.filter((_, index) => {
        return !selectedIndices.includes(index);
      });

      // Recalculate totals
      let current_debit_total_amount = 0;
      let current_credit_total_amount = 0;
      updatedData.forEach((item) => {
        current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
        current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      });

      setState({
        ...state,
        total_credit_amount: current_credit_total_amount,
        total_debit_amount: current_debit_total_amount,
      });
      setall_data({ ...all_data, voucherEntryList: updatedData });
      setRemovedItems(prev => [...prev, removedItemsList]);
      setSelectedItems([]); // Clear selection after removal
    } else {
      // If no multi-selection, remove single selected item (the one currently active)
      const updatedData = all_data?.voucherEntryList?.filter((_, index) => {
        return index !== selectedItemIndex;
      });

      const removedItem = all_data?.voucherEntryList[selectedItemIndex];

      let current_debit_total_amount = 0;
      let current_credit_total_amount = 0;
      updatedData.forEach((item) => {
        current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
        current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      });

      setState({
        ...state,
        total_credit_amount: current_credit_total_amount,
        total_debit_amount: current_debit_total_amount,
      });
      setall_data({ ...all_data, voucherEntryList: updatedData });
      setRemovedItems(prev => [...prev, [{ index: selectedItemIndex, item: removedItem }]]);
    }
  };

  // Function to restore selected items
  const restoreSelectedItems = () => {
    if (removedItems.length === 0) return;

    // Restore the last removed group (LIFO - Last In, First Out)
    const lastRemovedGroup = removedItems[removedItems.length - 1];

    // Create a copy of the current voucher entry list
    let updatedVoucherEntryList = [...all_data?.voucherEntryList];

    // Sort the group by original index to ensure correct insertion order
    const sortedGroup = [...lastRemovedGroup].sort((a, b) => a.index - b.index);

    sortedGroup.forEach(removed => {
      updatedVoucherEntryList.splice(removed.index, 0, removed.item);
    });

    const updatedData = {
      ...all_data,
      voucherEntryList: updatedVoucherEntryList,
    };

    // Recalculate totals
    let current_debit_total_amount = 0;
    let current_credit_total_amount = 0;
    updatedVoucherEntryList.forEach((item) => {
      current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
      current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
    });

    setState({
      ...state,
      total_credit_amount: current_credit_total_amount,
      total_debit_amount: current_debit_total_amount,
    });
    setall_data(updatedData);

    // Remove the restored group from removedItems stack
    setRemovedItems(prev => prev.slice(0, -1));
  };

  const formatCurrency = (number) => {
    const [wholePart, decimalPart] = Number(number).toFixed(2).split(".");
    const formattedWholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formattedWholePart}.${decimalPart}`;
  };


  useEffect(() => {
    if (all_data?.voucherEntryList?.[selectedItemIndex]) {
      setData({
        uid: all_data.voucherEntryList[selectedItemIndex]?.uid,
        company_id: userData?.company_id,
      });
    }
  }, [selectedItemIndex, all_data]);

  // Delete Functionality ------------------------------
  const { delteItem, loadingDelete } = useDelet({
    prepareFormData: () => {
      const formData = new FormData();
      if (selectedItems.length > 0) {
        const uidsArray = selectedItems.map((selectedIndex) => {
          const item = all_data?.voucherEntryList[selectedIndex];
          return (item?.uid && item?.uid !== 0 && item?.uid !== "0")
            ? item.uid
            : (item?.voucher_entries_id && item?.voucher_entries_id !== 0 && item?.voucher_entries_id !== "0")
              ? item.voucher_entries_id
              : item?.id;
        });
        const uidsString = uidsArray.filter(id => id).join(",");
        formData.append("uid", uidsString);
        formData.append("id", uidsString);
        formData.append("company_id", userData?.company_id);

        const firstItem = all_data?.voucherEntryList[selectedItems[0]];
        if (firstItem?.voucher_type_id) formData.append("voucher_type_id", firstItem.voucher_type_id);
        if (firstItem?.voucher_type_name) formData.append("voucher_type_name", firstItem.voucher_type_name);
      } else {
        const item = all_data?.voucherEntryList[selectedItemIndex];
        const deleteId = (item?.uid && item?.uid !== 0 && item?.uid !== "0")
          ? item.uid
          : (item?.voucher_entries_id && item?.voucher_entries_id !== 0 && item?.voucher_entries_id !== "0")
            ? item.voucher_entries_id
            : item?.id;

        formData.append("uid", deleteId);
        formData.append("id", deleteId);
        formData.append("company_id", userData?.company_id);
        if (item?.voucher_type_id) formData.append("voucher_type_id", item.voucher_type_id);
        if (item?.voucher_type_name) formData.append("voucher_type_name", item.voucher_type_name);
      }
      return formData;
    },
    submitForm: async (formData) => {
      const response = await dispatch(voucherEntryDelete(formData));
      if (response?.status) {
        setSelectedItems([]);
        setRefreshKey((prev) => prev + 1);
      }
      return response;
    },
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => delteItem(new Event("submit")),
      },
    ],
    closeModal: () => dispatch(closeModal("delete")),
    state: modal_state?.delete,
  });

  const AddVchFunction = () => {
    const selectedItem = all_data?.voucherEntryList[selectedItemIndex];
    if (selectedItem) {
      navigate(`../voucherstransaction`, {
        state: {
          create_date: dateFormateShow(selectedItem?.create_date),
          voucher_type_id: selectedItem?.voucher_type_id,
          voucher_type_name: selectedItem?.voucher_type_name
        }
      });
    } else {
      navigate(`../voucherstransaction`);
    }
  };

  const duplicateFunction = () => {
    const selectedItem = all_data?.voucherEntryList[selectedItemIndex];
    if (selectedItem) {
      navigate(`../voucher-transaction/${selectedItem?.voucher_entries_id !== 0 ? selectedItem?.voucher_entries_id : selectedItem?.uid}`);
    }
  };

  const deleteFunction = () => {
    dispatch(openModal("delete"));
  };

  const cancelFunction = () => {
    dispatch(openModal("delete"));
  };

  const restoreLineFunction = () => {
    if (removedItems.length === 0) return;
    const lastRemoved = removedItems[removedItems.length - 1];
    const updatedList = [...all_data.voucherEntryList];
    updatedList.splice(lastRemoved.index, 0, lastRemoved.item);
    setall_data({ ...all_data, voucherEntryList: updatedList });
    setRemovedItems(removedItems.slice(0, -1));
  };

  let cumulativeBalance = parseFloat(state?.opening_balance) || 0;
  return (
    <HomeLayout
      data={{
        toggleDetailedCondensed: () => {
          setState_configure((prev) => ({
            ...prev,
            formate_of_report: prev.formate_of_report === "Detailed" ? "Condensed" : "Detailed",
          }));
        },
        state_configure
      }}
    >
      {modal_state?.period ? (
        <div style={{ zIndex: 1000 }}>
          <PeriodDouble
            date={date}
            send_date={send_date}
            setall_data={setall_data}
            setrecord={setrecord}
            setDate={setDate}
            setsend_date={setsend_date}
            setLoading={setLoading}
          />
        </div>
      ) : null}
      {modal_state?.configure ? (
        <div style={{ zIndex: 10000 }}>
          <Configure setState_configure={setState_configure} />
        </div>
      ) : null}
      <div className="container-fluid">
        <NavLayout>
          <b>Ledger Voucher</b>
          <span>{`${date?.from_date} To ${date?.to}`}</span>
        </NavLayout>
        {loading ? (
          <Indicator />
        ) : (
          <>
            {modal_state?.delete ? (
              <DeletConfirm
                handleSubmit={delteItem}
                loading={loadingDelete}
                closeModal={() => dispatch(closeModal("delete"))}
              />
            ) : null}
            <div className="row">
              <div className="col-4">
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '70px', display: 'inline-block' }}>Ledger</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.ledger_name}
                  </span>
                </div>
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '70px', display: 'inline-block' }}>Address</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.address}
                  </span>
                </div>
              </div>
              <div className="col-4 p-0">
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '70px', display: 'inline-block' }}>Ac No</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.account_no}
                  </span>
                </div>
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '70px', display: 'inline-block' }}>Mobile</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.mobile_no}
                  </span>
                </div>
              </div>
              <div className="col-4 p-0">
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '135px', display: 'inline-block' }}>Aadhar Number</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.aadhaar}
                  </span>
                </div>
                <div className="d-flex align-items-center" style={{ height: '20px' }}>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', whiteSpace: 'nowrap', width: '135px', display: 'inline-block' }}>Transport Details</span>
                  <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#000', marginRight: '6px' }}>:</span>
                  <span className="text-truncate" style={{ fontSize: '13px', fontWeight: 'bold', color: '#000' }}>
                    {all_data?.main_ledger_record?.transport_detail}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-0 m-0">
                <div
                  className="row px-1 mt-0 border_2_1px_bottom  border_2_2px_top heading_dyn_creation_data "
                  style={{ height: 19.5 }}
                >
                  <div
                    className="col-1 pe-1 font_size"
                    style={{ width: "8%", textAlign: "right", height: 19.5 }}
                  >
                    Date
                  </div>

                  <div
                    className="col-4 ps-1 font_size"
                    style={{ width: "39%", textAlign: "left", height: 19.5 }}
                  >
                    Particular
                  </div>
                  {/* <div
                    className="col-1 font_size"
                    style={{ width: "9%", textAlign: "left", height: 19.5 }}
                  >
                    Intrest
                  </div>
                  <div
                    className="col-1 font_size"
                    style={{ width: "8%", textAlign: "left", height: 19.5 }}
                  >
                    Int Rec
                  </div> */}
                  <div
                    className="col-1 font_size p-0 text-start"
                    style={{ width: "11%", height: 19.5 }}
                  >
                    Vch Type
                  </div>
                  <div
                    className="col-1 font_size text-end "
                    style={{ width: "10%", height: 19.5 }}
                  >
                    Vch No.
                  </div>
                  <div
                    className="col-1 font_size m-0 p-0 pe-1"
                    style={{ width: "9.5%", textAlign: "right", height: 19.5 }}
                  >
                    Debit
                  </div>
                  <div
                    className="col-1 font_size m-0 p-0 pe-1"
                    style={{ width: "9.5%", textAlign: "right", height: 19.5 }}
                  >
                    Credit
                  </div>
                  <div
                    className="col-1 font_size "
                    style={{
                      textAlign: "right",
                      flex: "0 1 auto",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      width: "13%",
                      height: 19.5,
                    }}
                  >
                    Balance
                  </div>
                </div>
              </div>
            </div>

            <div className="row position-relative">
              {all_data?.voucherEntryList?.length === 0 && state?.opening_balance === 0 ? (
                <div className="col-12 d-flex align-items-center justify-content-center" style={{ height: "66vh" }}>
                  <p className="text-muted">No Record Found !...</p>
                </div>
              ) : (
                <div
                  className="col-12 m-0 p-0"
                  ref={boxRef}
                  style={{
                    height: "66vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <div className="row px-1 mt-0" style={{ height: 19.5 }}>
                    <div className="col-1 pe-1 font_size text-end" style={{ width: "8%" }}></div>
                    <div className="col-4 ps-1 font_size text-start" style={{ width: "39%", fontWeight: "bold" }}>
                      Opening Balance
                    </div>
                    <div className="col-1 font_size p-0 text-start" style={{ width: "11%" }}></div>
                    <div className="col-1 font_size text-end" style={{ width: "10%" }}></div>
                    <div
                      className="col-1 font_size m-0 p-0 pe-1"
                      style={{
                        width: "9.5%",
                        textAlign: "right",
                        fontWeight: "bold",
                      }}
                    >
                      {state?.opening_balance > 0
                        ? formatCurrency(state?.opening_balance)
                        : null}
                    </div>
                    <div
                      className="col-1 font_size m-0 p-0 pe-1"
                      style={{
                        width: "9.5%",
                        textAlign: "right",
                        fontWeight: "bold",
                      }}
                    >
                      {state?.opening_balance < 0
                        ? formatCurrency(state?.opening_balance)
                        : null}
                    </div>
                    <div className="col-1 font_size" style={{ width: "13%" }}></div>
                  </div>

                  {all_data?.voucherEntryList?.map((item, index) => {
                    //console.log("item", item);
                    cumulativeBalance +=
                      parseFloat(item?.total_debit_amount) -
                      parseFloat(item?.total_credit_amount);
                    return (
                      <div
                        key={index}
                        className={
                          selectedItems?.includes(index) ? "selected_multi" : ""
                        }
                      >
                        <div
                          className={`row px-1  mt-0  ${index === selectedItemIndex
                            ? selectedItems?.includes(index)
                              ? "selected_multi_selected"
                              : "selected"
                            : ""
                            }`}
                          onClick={(e) => {
                            e?.preventDefault();
                            setSelectedItemIndex(index);
                          }}
                          onDoubleClick={() => {
                            navigate(`../voucher-transaction-view/${item?.voucher_entries_id > 0 ? item?.voucher_entries_id : item?.uid}`);
                          }}
                        >
                          <div
                            className="col-1 pe-1 font_size text-end"
                            style={{ width: "8%" }}
                          >
                            {dateFormateShow(item?.create_date)}
                          </div>

                          <div
                            className="col-4 ps-1 font_size"
                            style={{
                              width: "39%",
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {state_configure?.formate_of_report === "Condensed"
                              ? (
                                item?.voucher_type?.toLowerCase().includes('purchase') ||
                                item?.voucher_type?.toLowerCase().includes('sale') ||
                                item?.voucher_type?.toLowerCase().includes('debit note') ||
                                item?.voucher_type?.toLowerCase().includes('credit note')
                              )
                                ? item?.particular_ledger_name
                                : item?.particular_ledger_pos?.[0]?.particular_ledger_name
                              : "(As per Details)"}
                          </div>
                          {/* <div
                            className="col-1 font_size"
                            style={{
                              width: "9%",
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {}
                          </div>
                          <div
                            className="col-1 font_size"
                            style={{
                              width: "8%",
                              textAlign: "left",
                              fontWeight: "bold",
                            }}
                          >
                            {}
                          </div> */}
                          <div
                            className="col-1 font_size p-0 text-start "
                            style={{ width: "11%", fontWeight: "bold" }}
                          >
                            {item?.voucher_type_name}
                          </div>
                          <div
                            className="col-1 font_size text-end"
                            style={{ width: "10%" }}
                          >
                            {item?.serial_no && !isNaN(item.serial_no) ? parseInt(item.serial_no, 10) : item?.serial_no}
                          </div>
                          <div
                            className="col-1 font_size  m-0 p-0 pe-1"
                            style={{
                              width: "9.5%",
                              textAlign: "right",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.total_debit_amount > 0
                              ? currencyFormate(
                                parseFloat(item?.total_debit_amount)
                              )
                              : null}
                          </div>
                          <div
                            className="col-1 font_size  m-0 p-0 pe-1"
                            style={{
                              width: "9.5%",
                              textAlign: "right",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.total_credit_amount > 0
                              ? currencyFormate(
                                parseFloat(item?.total_credit_amount)
                              )
                              : null}
                          </div>
                          <div
                            className={`col-1 font_size ${cumulativeBalance > 0 &&
                              !selectedItems?.includes(index)
                              ? "text-black"
                              : "text-red"
                              } ${selectedItems?.includes(index) ? "text-white" : ""
                              }`}
                            style={{
                              textAlign: "right",
                              flex: "0 1 auto",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              width: "13%",
                              // color: cumulativeBalance > 0 ? "black" : "red",
                              fontWeight: "bold",
                            }}
                          >
                            {cumulativeBalance > 0
                              ? `${currencyFormate(cumulativeBalance)} Dr`
                              : `${currencyFormate(cumulativeBalance)} Cr`}
                          </div>
                          {state_configure?.formate_of_report === "Detailed"
                            ? item?.particular_ledger_pos?.map(
                              (ledger, ledgerIndex) => (
                                <>
                                  <div className="col-12" key={ledgerIndex}>
                                    <div className="row">
                                      <div
                                        className="col-3 font_size offset-2"
                                        style={{ textAlign: "left" }}
                                      >
                                        {ledger?.particular_ledger_name}
                                      </div>
                                      <div
                                        className="col-2 font_size"
                                        style={{ textAlign: "left" }}
                                      >
                                        {`${formatCurrency(
                                          ledger?.particular_ledger_pay_amount > 0 ? ledger?.particular_ledger_pay_amount : ledger?.total_amount
                                        )} ${ledger?.transaction_type}`}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )
                            )
                            : null}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

          </>
        )}
      </div>
      <LedgerVoucherFooter
        isDisable={removedItems.length === 0}
        isSelectionEmpty={selectedItems.length === 0}
        AddVchFunction={() => navigate(`../voucherstransaction`, {
          state: {
            create_date: dateFormateShow(all_data?.voucherEntryList[selectedItemIndex]?.create_date),
            voucher_type_id: all_data?.voucherEntryList[selectedItemIndex]?.voucher_type_id,
            voucher_type_name: all_data?.voucherEntryList[selectedItemIndex]?.voucher_type_name
          }
        })}
        //AddVchFunction={() => navigate(`../voucherstransaction`)}
        spaceFunction={() => toggleSelection(selectedItemIndex)}
        duplicateFunction={() => navigate(`../voucher-transaction/${all_data?.voucherEntryList[selectedItemIndex]?.voucher_entries_id !== 0 ? all_data?.voucherEntryList[selectedItemIndex]?.voucher_entries_id : all_data?.voucherEntryList[selectedItemIndex]?.uid}`)}
        insertFunction={() => navigate(`../voucher-transaction/${all_data?.voucherEntryList[selectedItemIndex]?.voucher_entries_id !== 0 ? all_data?.voucherEntryList[selectedItemIndex]?.voucher_entries_id : all_data?.voucherEntryList[selectedItemIndex]?.uid}`)}
        deleteFunction={() => { dispatch(openModal('delete')) }}
        cancelFunction={() => { }}
        removeLineFunction={() => removeSelectedItems()}
        restoreLineFunction={() => restoreSelectedItems()}
      >
        <div className="row m-0 border_2_1px_top border_2_2px_bottom" style={{ width: '100%', background: '#fff', zIndex: 100 }}>
          <div className="col-12 p-0 m-0">
            <div className="row px-1 mt-0" style={{ height: 19.5 }}>
              <div className="col-1 pe-1 font_size text-end" style={{ width: "8%" }}></div>
              <div className="col-4 ps-1 font_size text-start" style={{ width: "39%" }}></div>
              <div className="col-1 font_size p-0 text-start" style={{ width: "11%" }}></div>
              <div className="col-1 font_size text-end" style={{ width: "10%", fontWeight: "bold" }}>
                Current Total :
              </div>
              <div
                className="col-1 m-0 p-0 pe-1 font_size"
                style={{ width: "9.5%", textAlign: "right" }}
              >
                <strong>
                  {currencyFormate(state?.total_debit_amount)}
                </strong>
              </div>
              <div
                className="col-1 m-0 p-0 pe-1 font_size"
                style={{ width: "9.5%", textAlign: "right" }}
              >
                <strong>
                  {currencyFormate(state?.total_credit_amount)}
                </strong>
              </div>
              <div className="col-1 font_size" style={{ width: "13%" }}></div>
            </div>
            <div className="row px-1 mt-0 border_2_1px_top" style={{ height: 19.5 }}>
              <div className="col-1 pe-1 font_size text-end" style={{ width: "8%" }}></div>
              <div className="col-4 ps-1 font_size text-start" style={{ width: "39%" }}></div>
              <div className="col-1 font_size p-0 text-start" style={{ width: "11%" }}></div>
              <div className="col-1 font_size text-end" style={{ width: "10%", fontWeight: "bold" }}>
                Closing Balance :
              </div>
              <div
                className="col-1  m-0 p-0 pe-1 font_size"
                style={{ width: "9.5%", textAlign: "right", position: "relative" }}
              >
                <strong>
                  {closing_balance > 0
                    ? currencyFormate(closing_balance)
                    : null}
                </strong>
                {closing_balance > 0 && (
                  <span style={{ position: "absolute", left: "100%", paddingLeft: "4px", whiteSpace: "nowrap", fontWeight: "bold" }}>
                    Dr
                  </span>
                )}
              </div>
              <div
                className="col-1 m-0 p-0 pe-1 font_size"
                style={{ width: "9.5%", textAlign: "right", color: "red", position: "relative" }}
              >
                <strong>
                  {closing_balance < 0
                    ? currencyFormate(Math.abs(closing_balance))
                    : null}
                </strong>
                {closing_balance < 0 && (
                  <span style={{ position: "absolute", left: "100%", paddingLeft: "4px", whiteSpace: "nowrap", fontWeight: "bold", color: "red" }}>
                    Cr
                  </span>
                )}
              </div>
              <div className="col-1 font_size" style={{ width: "13%" }}></div>
            </div>
          </div>
        </div>
      </LedgerVoucherFooter>
    </HomeLayout>
  );
};

export default LedgerVoucher;

function PeriodDouble(props) {
  const dispatch = useDispatch();
  const [date, setdate] = useState({
    from: props.date?.from_date || "",
    to: props.date?.to || "",
    show_date: props.send_date?.from_date || "",
  });
  const from_input_ref = useRef(null);
  const to_input_ref = useRef(null);
  const { company_session } = useSelector((state) => state.common);

  useEffect(() => {
    if (from_input_ref.current) {
      from_input_ref.current.focus();
      from_input_ref.current.select();
    }
  }, []);

  useEffect(() => {
    if (props?.date && props?.send_date) {
      setdate({
        from: props.date.from_date || "",
        to: props.date.to || "",
        show_date: props.send_date.from_date || "",
      });
    }
  }, [props.date, props.send_date]);

  const handlechange = (e) => {
    const { name, value } = e?.target;
    setdate((prevDate) => ({ ...prevDate, [name]: value }));
    if (name === "from") {
      if (e?.key === "Enter") {
        e?.preventDefault();
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.start_financial_year) {
            inputValue = new Date(company_session.start_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        if (inputValue !== '') {
          const result = getValidPeriodDate(inputValue, company_session, company_session?.current_date_1);

          if (result) {
            setdate({
              ...date,
              from: result.formattedDateString,
              show_date: result.formattedDateString,
            });
            to_input_ref.current.focus();
            to_input_ref.current.select();
          } else {
            alert("Invalid Date.");
          }
        }
      }
    }
    if (name === "to") {
      if (e?.key === "Enter" && date?.from !== "") {
        e?.preventDefault();
        let inputValue = value.trim();
        if (inputValue === '') {
          if (company_session?.end_financial_year) {
            inputValue = new Date(company_session.end_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
          }
        }
        if (inputValue !== '') {
          const result = getValidPeriodDate(inputValue, company_session, date.from);

          if (result) {
            const from_date_check = new Date(date?.show_date);
            const formattedDateString_send = dateFormateSend(result.formattedDateString);

            // Validation: to_date >= from_date
            if (new Date(formattedDateString_send) < from_date_check) {
              alert("To Date cannot be less than From Date");
              return;
            }

            props?.setDate({
              from_date: date?.from,
              to: result.formattedDateString,
            });
            props?.setsend_date({
              from_date: dateFormateSend(date?.from),
              to_date: formattedDateString_send,
            });
            props.setLoading(true);
            dispatch(closeModal("period"));
          } else {
            alert("Invalid Date.");
          }
        }
      }
    }
  };

  useEffect(() => {
    const handlekeydown = (e) => {
      if (e?.key === "Escape") {
        e?.preventDefault();
        dispatch(closeModal("period"));
        e?.stopPropagation();
      }
    };
    document.addEventListener("keydown", handlekeydown);
    return () => {
      document.removeEventListener("keydown", handlekeydown);
    };
  }, [props?.data, date]);
  const { from, to } = date;
  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          dispatch(closeModal("period"));
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div className="container pb-3" id="card-period">
        <div className="row">
          <div className="col">
            <b className="border-bottom">Voucher Date</b>
          </div>
        </div>
        <div className="row">
          <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
            <div className="col">
              <div className="d-flex justify-content-between align-item-center">
                <label className="lab-1">From Date</label>
                <label>:</label>
                <input
                  type="text"
                  autoFocus
                  name="from"
                  id="from"
                  ref={from_input_ref}
                  onFocus={(e) => e.target.select()}
                  onChange={handlechange}
                  onKeyUp={handlechange}
                  value={from || ""}
                  className="lab-right"
                />
              </div>
              <div className="d-flex justify-content-between align-item-center">
                <label className="lab-1">To</label>
                <label>:</label>
                <input
                  type="text"
                  name="to"
                  id="to"
                  ref={to_input_ref}
                  onFocus={(e) => e.target.select()}
                  onChange={handlechange}
                  onKeyUp={handlechange}
                  value={to || ""}
                  className="lab-right"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}

function Configure(props) {
  const dispatch = useDispatch();
  const modal_state = useSelector((state) => state.common.modal_state);
  const [state, setState] = useState({
    show_narrations: "No",
    formate_of_report: "Condensed",
    show_bill_wise_details: "No",
    show_inventory_details: "No",
    show_mode_of_payment: "No",
    show_additional_bank_details: "No",
    display_name_for_ledgers: "Name Only",
    display_name_for_stock_items: "Name Only",
    sorting_method: "Default",
    show_running_balance: "Yes",
  });
  const show_narrations_input_ref = useRef(null);
  const formate_of_report_input_ref = useRef(null);
  const show_bill_wise_details_input_ref = useRef(null);
  const show_inventory_details_input_ref = useRef(null);
  const show_mode_of_payment_input_ref = useRef(null);
  const show_additional_bank_details_input_ref = useRef(null);
  const display_name_for_ledgers_input_ref = useRef(null);
  const display_name_for_stock_items_input_ref = useRef(null);
  const sorting_method_input_ref = useRef(null);
  const show_running_balance_input_ref = useRef(null);

  const handlechange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
    // space key functionality
    if (e.code == "Space") {
      e.preventDefault();
      const cursorPosition_start = e.target.selectionStart;
      if (cursorPosition_start == 1) {
        setState({ ...state, [name]: "" });
        return;
      }
    }
    // Enter key functionality
    if (e.key === "Enter") {
      e.preventDefault();
      const nextInputRef =
        name === "show_narrations"
          ? formate_of_report_input_ref
          : name === "formate_of_report"
            ? show_bill_wise_details_input_ref
            : name === "show_bill_wise_details"
              ? show_inventory_details_input_ref
              : name === "show_inventory_details"
                ? show_mode_of_payment_input_ref
                : name === "show_mode_of_payment"
                  ? show_additional_bank_details_input_ref
                  : name === "show_additional_bank_details"
                    ? display_name_for_ledgers_input_ref
                    : name === "display_name_for_ledgers"
                      ? display_name_for_stock_items_input_ref
                      : name === "display_name_for_stock_items"
                        ? sorting_method_input_ref
                        : name === "sorting_method"
                          ? show_running_balance_input_ref
                          : null;
      if (name === "show_running_balance") {
        if (e.key === "Enter") {
          e.preventDefault();
          props.setState_configure({
            show_narrations: state?.show_narrations,
            formate_of_report: state?.formate_of_report,
            show_bill_wise_details: state?.show_bill_wise_details,
            show_inventory_details: state?.show_inventory_details,
            show_mode_of_payment: state?.show_mode_of_payment,
            show_additional_bank_details: state?.show_additional_bank_details,
            display_name_for_ledgers: state?.display_name_for_ledgers,
            display_name_for_stock_items: state?.display_name_for_stock_items,
            sorting_method: state?.sorting_method,
            show_running_balance: state?.show_running_balance,
          });
          dispatch(closeModal("configure"));
        }
      }
      if (nextInputRef) {
        nextInputRef.current.focus();
        if (nextInputRef.current) {
          nextInputRef.current.setSelectionRange(
            0,
            nextInputRef?.current?.value?.length
          );
        }
      }
      return;
    }
    // Back space key functionality
    if (e.key === "Backspace") {
      e.preventDefault();
      const prevInputRef =
        name === "formate_of_report"
          ? show_narrations_input_ref
          : name === "show_bill_wise_details"
            ? formate_of_report_input_ref
            : name === "show_inventory_details"
              ? show_bill_wise_details_input_ref
              : name === "show_mode_of_payment"
                ? show_inventory_details_input_ref
                : name === "show_additional_bank_details"
                  ? show_mode_of_payment_input_ref
                  : name === "display_name_for_ledgers"
                    ? show_additional_bank_details_input_ref
                    : name === "display_name_for_stock_items"
                      ? display_name_for_ledgers_input_ref
                      : name === "sorting_method"
                        ? display_name_for_stock_items_input_ref
                        : name === "show_running_balance"
                          ? sorting_method_input_ref
                          : null;
      const cursorPosition = e.target.selectionStart;
      if (cursorPosition === 0) {
        prevInputRef.current.focus();
        if (prevInputRef.current) {
          prevInputRef.current.setSelectionRange(0, 0);
        }
      }
      return;
    }
  };
  const {
    show_narrations,
    formate_of_report,
    show_bill_wise_details,
    show_inventory_details,
    show_mode_of_payment,
    show_additional_bank_details,
    display_name_for_ledgers,
    display_name_for_stock_items,
    sorting_method,
    show_running_balance,
  } = state;
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        dispatch(closeModal("configure"));
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [modal_state?.configure]);
  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          dispatch(closeModal("configure"));
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div
        className="container pb-3 border border-dark"
        id="card-period"
        style={{ width: "60%", background: "#fff" }}
      >
        <div className="row">
          <div className="col border-bottom">
            <b>Configure</b>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="m-0 p-0 mb-1 border-bottom border-gray">
              General Details
            </p>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Narration</label>
              <label>:</label>
              <input
                type="text"
                autoFocus
                name="show_narrations"
                id="show_narrations"
                ref={show_narrations_input_ref}
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_narrations || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Formate of Report</label>
              <label>:</label>
              <input
                type="text"
                name="formate_of_report"
                ref={formate_of_report_input_ref}
                id="formate_of_report"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={formate_of_report || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Bill Wise Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_bill_wise_details"
                id="show_bill_wise_details"
                ref={show_bill_wise_details_input_ref}
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_bill_wise_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Inventory Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_inventory_details"
                ref={show_inventory_details_input_ref}
                id="show_inventory_details"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_inventory_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Mode of Payment</label>
              <label>:</label>
              <input
                type="text"
                name="show_mode_of_payment"
                ref={show_mode_of_payment_input_ref}
                id="show_mode_of_payment"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_mode_of_payment || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Additional Bank Details</label>
              <label>:</label>
              <input
                type="text"
                name="show_additional_bank_details"
                ref={show_additional_bank_details_input_ref}
                id="show_additional_bank_details"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_additional_bank_details || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Display Name For Ledgers</label>
              <label>:</label>
              <input
                type="text"
                name="display_name_for_ledgers"
                ref={display_name_for_ledgers_input_ref}
                id="display_name_for_ledgers"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={display_name_for_ledgers || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Display name for stock items</label>
              <label>:</label>
              <input
                type="text"
                name="display_name_for_stock_items"
                ref={display_name_for_stock_items_input_ref}
                id="display_name_for_stock_items"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={display_name_for_stock_items || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Sorting Method</label>
              <label>:</label>
              <input
                type="text"
                name="sorting_method"
                ref={sorting_method_input_ref}
                id="sorting_method"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={sorting_method || ""}
                className="lab-right"
              />
            </div>
            <div className="d-flex justify-content-between align-item-center">
              <label className="lab-1">Show Running Balance</label>
              <label>:</label>
              <input
                type="text"
                name="show_running_balance"
                ref={show_running_balance_input_ref}
                id="show_running_balance"
                onChange={handlechange}
                onKeyUp={handlechange}
                value={show_running_balance || ""}
                className="lab-right"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
}